import React, {useState} from 'react'
import { ChevronLeft } from 'lucide-react'

const CloseSidebarBtn = ({onClick, hoverBgColor="bg-gray-600", tooltipMessage="サイドバーを閉じる", tooltipRight=""}) => {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div className="flex items-center space-x-2 absolute top-4 right-2 chat-close-sidebar">
            <button
                onClick={onClick}
                className={`p-2 rounded-full text-gray-300 hover:${hoverBgColor} focus:outline-none focus:ring-2 focus:ring-gray-600 transition-colors duration-200`}
                aria-label={tooltipMessage}
                onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}
                >
                <ChevronLeft className="h-6 w-6" />
            </button>
            {showTooltip ? <div className={`bg-gray-400 text-white p-2 rounded-lg text-xs absolute top-[45px] w-[120px] ${tooltipRight}`}>{tooltipMessage}</div> : null}
        </div>
    );
}

export default CloseSidebarBtn